import "./PagePresentation.scss";

const PagePresentation_QuiEstElectre = () => {
  return (
    <>
          <div className="col col-md-10 offset-md-1 col-12">
            <div className="titre titre-Presentation text-center">
              Qui Est <span className="word">E</span>lectre ?
            </div>
          </div>

          <div className={`col-lg-8 offset-lg-2 col-md-10 offset-md-1 col-sm-10 offset-sm-1 mt-4 d-flex justify-content-md-start`}>
        <div className="text-start">

            <p>
              <b>
              La société Electre, filiale du Cercle de la Librairie est composée de trois pôles complémentaires : Electre Data Services, Livres Hebdo et les Editions du Cercle de la Librairie.
              </b>
            </p>

            <p>
              <b>Electre Data Services</b> conçoit, développe et propose un bouquet de services autour de la base de données bibliographiques des professionnels du livre. 
              Cette base comprend plus de 3,5 millions de références, enrichies de plus de 1,5 million de produits culturels (livres, musique, films et jeux vidéo).
              <br/>
              Nous nous inscrivons pleinement dans la chaîne de valeur du livre et prenons en charge des activités globales de référencement normalisé pour le monde de l’édition :
           </p>
           <ul>
            <li>Données bibliographiques de référence sur le marché francophone</li>
            <li>Annuaire professionnel de l’édition francophone - accessible aux abonnés</li>
            <li>Attribution des ISBN pour l’édition française, belge et de l’Afrique francophone</li>
           </ul>             

            <p>
              <b>Livres Hebdo</b> est le pôle média de référence des professionnels du livre. 
              Il propose une couverture complète de l’actualité du secteur à travers des articles, analyses et services dédiés au développement des métiers. 
              Ses publications incluent « Livres de la Semaine » et « Livres du Mois », qui permettent d’anticiper les sorties d’ouvrages et de faciliter les acquisitions. 
              Avec une approche rigoureuse et experte, Livres Hebdo accompagne éditeurs, 
              libraires et bibliothécaires en leur fournissant des informations stratégiques et des outils pour rester à la pointe du marché.
            </p>

            <p>
              <b>Les Éditions du Cercle de la Librairie</b> publient des ouvrages spécialisés pour les professionnels et les passionnés du livre.
            </p>
            </div>
            </div>
          </>
  );
};

export default PagePresentation_QuiEstElectre;
